import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onewaytaximumbaitopune() {



const cardData = {
  keyword: " One Way Taxi Mumbai to Pune  ",

headingDescription: "Velocity Cab provides reliable and comfortable one-way taxi services from Mumbai to Pune, ensuring a hassle-free and punctual journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and timely pickups make traveling from Mumbai to Pune convenient and stress-free. We offer flexible options including air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With transparent pricing, easy online booking, and 24/7 customer support, Velocity Cab is the trusted choice for one-way Mumbai to Pune taxi travel.",

topPlaces: [
  
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a famous hill fort near Pune, known for its historical importance and scenic views. Travelers using a one-way taxi from Mumbai can enjoy trekking trails, explore ancient gates and bastions, and experience panoramic views of the Sahyadri mountains. Local stalls at the fort offer traditional Maharashtrian food like pithla bhakri, adding to the experience."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered temples dedicated to Lord Ganesha. Travelers from Mumbai often visit this temple for blessings and to experience the vibrant spiritual atmosphere. The temple is beautifully decorated throughout the year and becomes especially lively during Ganesh Chaturthi. Nearby markets offer flowers, sweets, and religious items."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva and carved from a single rock. Located in central Pune, it is known for its unique architecture and tranquil surroundings. Travelers from Mumbai using a one-way taxi can explore the temple’s stone pillars and carvings, ideal for meditation, photography, and peaceful spiritual experience."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is one of Pune’s most iconic historical landmarks and once served as the residence of the Peshwas of the Maratha Empire. Travelers using a one-way taxi from Mumbai can explore its massive entrance gates, fort walls, and the ruins of the grand palace complex. The site also features an evening light and sound show narrating the fascinating history of the Maratha dynasty. Visitors enjoy photography, cultural exploration, and leisurely walks through the historic grounds."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a historically significant monument in Pune associated with Mahatma Gandhi and the Indian freedom struggle. Travelers arriving via one-way taxi from Mumbai can admire its elegant architecture, beautifully maintained gardens, and museum displaying historical artifacts. The serene surroundings make it ideal for sightseeing, photography, and learning about India’s independence movement."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases thousands of artifacts representing Indian heritage and craftsmanship. Travelers from Mumbai can explore exhibits featuring musical instruments, sculptures, decorative objects, and traditional household items. The museum offers insights into India’s culture, art, and historical lifestyle."
  },
  {
    title: "Parvati Hill Temple",
    description: "Parvati Hill Temple is one of Pune’s oldest heritage sites and offers panoramic views of the city. Travelers from Mumbai can climb the steps leading to the temple complex dedicated to Lord Shiva and other deities. The hilltop location is perfect for sightseeing, photography, and enjoying peaceful moments overlooking Pune."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a scenic water reservoir on Pune’s outskirts, popular among nature lovers. Travelers using a one-way taxi from Mumbai can enjoy lake views, refreshing breezes, and picturesque sunsets. The area is ideal for picnics, photography, and relaxing walks amidst the surrounding hills."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a Japanese-style landscaped garden in Pune. Travelers arriving from Mumbai can stroll along its pathways, admire lotus ponds, bonsai trees, and lush greenery. The serene environment makes it perfect for relaxation, nature walks, and photography."
  },
  {
    title: "Lal Mahal",
    description: "Lal Mahal is a historic palace associated with the childhood of Chhatrapati Shivaji Maharaj and an important cultural landmark in Pune. Travelers using a one-way taxi from Mumbai can explore the reconstructed palace with sculptures and exhibits depicting scenes from Shivaji Maharaj’s life. It provides insights into Maratha history and Pune’s cultural heritage."
  }
],



services: [
{
name: "Mumbai to Pune Cab",
description: "Mumbai to Pune cab service offers a smooth and reliable travel experience via the Mumbai–Pune Expressway, making it one of the most preferred intercity routes in Maharashtra. Travelers can choose from sedan, Ertiga, and Innova Crysta vehicles based on comfort and group size. This service is ideal for corporate travel, family trips, airport transfers, and weekend getaways. Professional drivers ensure timely pickup from any location in Mumbai including homes, hotels, offices, and railway stations. Air-conditioned vehicles, clean interiors, and spacious seating provide a comfortable journey. Online booking with instant confirmation and transparent pricing makes travel planning easy and stress-free."
},
{
name: "Mumbai Airport to Pune Cab",
description: "Mumbai airport to Pune cab service provides direct pickup from Terminal 1 and Terminal 2 with timely drop to any location in Pune. Drivers monitor flight timings to ensure smooth airport transfers without waiting charges. This service is ideal for travelers arriving in Mumbai and heading to Pune for business or personal reasons. Comfortable vehicles and professional drivers ensure a relaxed journey after long flights."
},
{
name: "Mumbai to Pune Taxi",
description: "Mumbai to Pune taxi service offers dependable and comfortable travel with experienced drivers and well-maintained vehicles. Pickup is available from all major locations across Mumbai including Andheri, Dadar, Borivali, and Navi Mumbai. This service is widely used by professionals, families, and tourists for safe intercity travel."
},
{
name: "Mumbai to Pune Cab Price",
description: "Mumbai to Pune cab price depends on vehicle type, travel time, and trip type such as one-way or round trip. Sedan options are budget-friendly while Ertiga and Innova Crysta provide premium comfort. Transparent pricing ensures no hidden charges including tolls and driver allowance."
},
{
name: "Mumbai to Pune Cab Service",
description: "Mumbai to Pune cab service ensures smooth and hassle-free travel with flexible pickup options and comfortable vehicles. This service is ideal for daily commuters, business travel, and family trips with reliable and timely service."
},
{
name: "Mumbai to Pune Taxi Price",
description: "Mumbai to Pune taxi price offers competitive and transparent fare details helping travelers choose the best option based on budget and comfort. Pricing varies depending on vehicle type and travel requirements."
},
{
name: "Mumbai Pune Car Rental",
description: "Mumbai Pune car rental service provides flexible vehicle options for intercity travel with driver support. Customers can choose from economy to luxury vehicles for a comfortable and convenient journey."
},
{
name: "Mumbai Pune Cab One Way",
description: "Mumbai Pune one way cab service offers cost-effective travel without return charges. This service is ideal for passengers requiring single-direction trips such as airport transfers or business travel."
},
{
name: "Mumbai to Pune Cab from Airport",
description: "Mumbai airport to Pune cab service ensures direct and convenient travel from airport terminals to Pune with professional drivers and comfortable vehicles."
},
{
name: "Pune to Mumbai Taxi One Way",
description: "Pune to Mumbai one way taxi service provides affordable travel for passengers traveling from Pune to Mumbai without return charges. Flexible pickup and drop options make it highly convenient."
},
{
name: "Cab for Mumbai to Pune",
description: "Cab for Mumbai to Pune offers reliable intercity transportation with comfortable vehicles and experienced drivers ensuring safe travel."
},
{
name: "Cab Service Mumbai to Pune",
description: "Cab service Mumbai to Pune provides dependable travel with well-maintained vehicles and professional drivers ensuring a smooth journey."
},
{
name: "Mumbai Pune Cab Fare",
description: "Mumbai Pune cab fare service provides transparent pricing including toll charges, driver allowance, and per km rates helping travelers plan their journey efficiently."
},
{
name: "Mumbai International Airport to Pune Cab",
description: "Mumbai international airport to Pune cab service offers direct pickup from international terminals with smooth and comfortable travel to Pune city."
},
{
name: "Cab Booking Mumbai to Pune",
description: "Cab booking Mumbai to Pune allows travelers to reserve taxis online with instant confirmation and flexible scheduling options."
},
{
name: "Mumbai to Pune One Way Taxi",
description: "Mumbai to Pune one way taxi service provides economical travel with no return fare, making it ideal for single-trip passengers."
},
{
name: "Mumbai to Pune One Way Cab",
description: "Mumbai to Pune one way cab service offers affordable and convenient travel with flexible pickup options and comfortable vehicles."
},
{
name: "One Way Taxi Mumbai to Pune",
description: "One way taxi Mumbai to Pune provides cost-effective travel for passengers looking for single-direction journeys with professional drivers."
},
{
name: "Mumbai to Pune One Way Cab Service",
description: "Mumbai to Pune one way cab service ensures reliable travel with well-maintained vehicles and experienced drivers for a smooth journey."
},
{
name: "Mumbai to Pune One Way Taxi Fare",
description: "Mumbai to Pune one way taxi fare offers transparent pricing helping travelers plan their travel budget efficiently."
},
{
name: "One Way Cab from Mumbai to Pune",
description: "One way cab from Mumbai to Pune provides flexible and affordable travel options for single-direction trips."
},
{
name: "Mumbai to Pune One Way Taxi Booking",
description: "Mumbai to Pune one way taxi booking allows easy online reservations with instant confirmation and hassle-free travel planning."
},
{
name: "Cheap One Way Cab Mumbai to Pune",
description: "Cheap one way cab Mumbai to Pune service offers budget-friendly travel options with reliable vehicles and professional drivers."
},
{
name: "Mumbai to Pune One Way Taxi Price",
description: "Mumbai to Pune one way taxi price provides competitive and transparent fare options depending on vehicle type and travel requirements."
},
{
name: "Mumbai to Pune Single Trip Cab",
description: "Mumbai to Pune single trip cab service offers convenient and economical travel for passengers needing one-way transportation."
},
{
name: "Mumbai to Pune One Side Taxi",
description: "Mumbai to Pune one side taxi service provides affordable travel for passengers traveling in one direction without return charges."
},
{
name: "Book One Way Taxi Mumbai to Pune",
description: "Book one way taxi Mumbai to Pune easily through online platforms with instant confirmation, flexible scheduling, and transparent pricing."
}
],

tableData: [
["Mumbai to Pune Cab","Mumbai Airport to Pune Cab"],
["Mumbai to Pune Taxi","Mumbai to Pune Cab Price"],
["Mumbai to Pune Cab Service","Mumbai to Pune Taxi Price"],
["Mumbai Pune Car Rental","Mumbai Pune Cab One Way"],
["Mumbai to Pune Cab from Airport","Pune to Mumbai Taxi One Way"],
["Cab for Mumbai to Pune","Cab Service Mumbai to Pune"],
["Mumbai Pune Cab Fare","Mumbai International Airport to Pune Cab"],
["Cab Booking Mumbai to Pune","Mumbai to Pune One Way Taxi"],
["Mumbai to Pune One Way Cab","One Way Taxi Mumbai to Pune"],
["Mumbai to Pune One Way Cab Service","Mumbai to Pune One Way Taxi Fare"],
["One Way Cab from Mumbai to Pune","Mumbai to Pune One Way Taxi Booking"],
["Cheap One Way Cab Mumbai to Pune","Mumbai to Pune One Way Taxi Price"],
["Mumbai to Pune Single Trip Cab","Mumbai to Pune One Side Taxi"],
["Book One Way Taxi Mumbai to Pune","Mumbai to Pune Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Affordable One Way Taxi Service",
    WhyChoosedescription: "Velocity Cabs offers budget-friendly one way taxi service from Mumbai to Pune, allowing customers to pay only for a single journey without return charges."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are experienced in Mumbai to Pune travel via the Mumbai Pune Expressway, ensuring safe driving, smooth journeys, and timely drop-offs."
  },
  {
    WhyChooseheading: "Transparent One Way Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent pricing for one way taxi bookings. Customers receive clear fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 One Way Cab Availability",
    WhyChoosedescription: "Our Mumbai to Pune one way taxi service operates 24/7. Whether you need early morning travel or late night rides, Velocity Cabs ensures reliable availability anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and hassle-free long-distance travel experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for all travel needs."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports across Mumbai for smooth one way travel to Pune."
  },
  {
    WhyChooseheading: "Trusted Intercity Taxi Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Pune one way taxi bookings thanks to punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide one way taxi from Mumbai to Pune?", answer: "Yes, Velocity Cabs provides reliable one way taxi services from Mumbai to Pune at affordable rates." },
  { question: "What is the benefit of one way taxi service?", answer: "One way taxi service allows you to pay only for a single trip without return charges, making it more economical." },
  { question: "Is Mumbai to Pune one way taxi available 24 hours?", answer: "Yes, our one way taxi service operates 24/7 for customer convenience." },
  { question: "How far is Mumbai from Pune?", answer: "The road distance between Mumbai and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Which vehicles are available for one way taxi?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book one way taxi online?", answer: "Yes, customers can easily book Mumbai to Pune one way taxi services online or through phone booking." },
  { question: "Do you provide airport pickup for one way taxi?", answer: "Yes, we provide pickup from Mumbai Airport, homes, hotels, and offices." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable travel." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during peak travel time." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Mehta",
    feedback:
      "Smooth and comfortable experience with the one way taxi from Mumbai to Pune. The cab was punctual, clean, and the highway ride felt very relaxed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The one way taxi service from Mumbai to Pune was very convenient. The journey was well-managed, the driver was professional, and everything felt safe and stress-free.",
    rating: 5
  }
];






























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const mumbaiToPuneOneWayJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Pune One Way Taxi | Velocity Cabs",
  "description": "Book a reliable one-way taxi from Mumbai to Pune with Velocity Cabs. Options include airport pickup/drop, Innova, Ertiga, and Sedan cabs. Affordable and safe cab service.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "One Way Taxi Mumbai to Pune",
    "Mumbai to Pune Airport Cab",
    "Mumbai to Pune One Way Cab Service",
    "Single Trip Cab Mumbai to Pune",
    "Mumbai to Pune One Side Taxi"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Mumbai to Pune One Way Taxi | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a one-way taxi from Mumbai to Pune with Velocity Cabs. Airport pickups, Innova, Ertiga, and Sedan cabs available. Safe, reliable, and affordable service."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiToPuneOneWayJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/68.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onewaytaximumbaitopune;